import { render, staticRenderFns } from "./EditAssistance.vue?vue&type=template&id=4013db5e&"
import script from "./EditAssistance.vue?vue&type=script&lang=js&"
export * from "./EditAssistance.vue?vue&type=script&lang=js&"
import style0 from "./EditAssistance.vue?vue&type=style&index=0&id=4013db5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports